import * as net from 'util/Net';

import {Request, RequestFullfillableStatuses} from './RequestConstants';

export function fetchRequest(requestId: string): Promise<{request: Request}> {
  return Promise.resolve(net.getJSON(`/1/api/requests/${requestId}`));
}

export function requestEditorURL(requestId: string): string {
  return `/requests/${requestId}`;
}

export function getFulfillableStatuses(
  requestIds: Array<string>
): Promise<{[requestId: string]: RequestFullfillableStatuses}> {
  return Promise.resolve(
    net.postJSON({url: '/1/api/requests:bulk-get-fulfillable-statuses', data: {requestIds}})
  );
}
